// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3flDU","col":"Table_col__2vEi6","fulfillmentStatus":"Table_fulfillmentStatus__1GAhv","emailCol":"Table_emailCol__1ethR"};